import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class DetailMedien extends Component {
  render() {
    return (
      <div>
        {this.props.medien.images.map(({ src, beschreibung }) => (
          <div className="row" key={src}>
            <div className="span4 detail-space-top-element">
              <img src={src} alt={beschreibung} width="300" />
              <div className="detail-space-top-element">{beschreibung}</div>
            </div>
          </div>
        ))}
        {this.props.medien.medium.map(({ src, beschreibung }) => (
          <div className="row" key={src}>
            <div className="span4 detail-space-top-element">
              <i className="icon ion-document medium-beschreibung" />{" "}
              <a href={src}>{beschreibung}</a>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(DetailMedien);



// WEBPACK FOOTER //
// ./src/detail/DetailMedien.js